import { Navbar as BsNavbar, Container, Button, Form, InputGroup } from "react-bootstrap";

interface NavbarProps {
  theme: "light" | "dark";
  onToggleTheme: () => void;
  onReset: () => void;
  playerSearch: string;
  onPlayerSearchChange: (value: string) => void;
}

export default function Navbar({
  theme,
  onToggleTheme,
  onReset,
  playerSearch,
  onPlayerSearchChange,
}: NavbarProps) {
  return (
    <BsNavbar className="bg-body-tertiary">
      <Container fluid className="flex-wrap gap-2">
        <BsNavbar.Brand
          role="button"
          tabIndex={0}
          onClick={onReset}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onReset();
            }
          }}
        >
          <img
            src="/slpmeup-logo-transparent.svg"
            alt="Logo"
            width="36"
            height="36"
            className="d-inline-block align-middle me-1"
          />
          SlpMeUp
        </BsNavbar.Brand>

        <InputGroup size="sm" className="flex-fill" style={{ minWidth: 180, maxWidth: 360 }}>
          <InputGroup.Text>
            <i className="bi bi-search" />
          </InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Search players..."
            value={playerSearch}
            onChange={(e) => onPlayerSearchChange(e.target.value)}
          />
          {playerSearch && (
            <>
              <Button
                variant="outline-secondary"
                onClick={() => onPlayerSearchChange("")}
                aria-label="Clear player search"
              >
                <i className="bi bi-x-lg" />
              </Button>
              <InputGroup.Text
                className="d-none d-sm-flex text-truncate"
                style={{ maxWidth: 120 }}
                title={`Filtered by: ${playerSearch}`}
              >
                <i className="bi bi-funnel-fill me-1" />
                <span className="text-truncate">{playerSearch}</span>
              </InputGroup.Text>
            </>
          )}
        </InputGroup>

        <div className="d-flex gap-2 justify-content-end ms-auto">
          <Button
            variant="outline-secondary"
            size="sm"
            className="flex-shrink-0 btn-theme-toggle"
            onClick={onToggleTheme}
            title="Toggle light/dark mode"
          >
            {theme === "light" ? (
              <>
                <i className="bi bi-brightness-high-fill" /> Light
              </>
            ) : (
              <>
                <i className="bi bi-moon-stars-fill" /> Dark
              </>
            )}
          </Button>
          <Button variant="outline-secondary" size="sm" href="/admin">
            <i className="bi bi-gear me-1"></i>
            Admin
          </Button>
        </div>
      </Container>
    </BsNavbar>
  );
}
